import { LANGUAGE_ACTION_TYPES } from '../actions/actionTypes';

export const getLanguageText = language => {
    return {
        type: LANGUAGE_ACTION_TYPES.SELECTED_LANGUAGE,
        language
    }
}
